import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {OptionModel} from '../../../vss-ui.model';

@Component({
  selector: 'vss-ui-pagination-2',
  templateUrl: './cs-pagination-2.component.html',
  styleUrls: ['./cs-pagination-2.component.scss']
})
export class CsPagination2Component implements OnInit {

  @Input() pageSize: number = 10;
  @Input() currentPage:number = 1;
  @Input() isShowSizeChanger: boolean = false;
  @Input() isShowQuickJumper: boolean = false;
  @Input() totalItem:number = 0;
  @Input() pageSizeOptions: number[] = [10, 20, 50, 100];
  @Input() export:boolean = false;

  @Output() onClickBtnExcel = new EventEmitter<void>();
  @Output() onPageSizeChange = new EventEmitter<number>();
  @Output() onPageIndexChange = new EventEmitter<number>();

  startItem: number = 1;
  endItem: number = 10;
  sizeOptions:OptionModel[] = [];

  constructor() { }

  ngOnInit() {
    this.setValueTotalTemp();
    this.sizeOptions = this.pageSizeOptions.map(x=>({value:x, label:x.toString()})) as OptionModel[];
  }

  changePageSize(value: number) {
    this.pageSize = value;
    this.setValueTotalTemp();
    this.onPageSizeChange.emit(value);
  }

  changePageIndex(value: number) {
    this.currentPage = value;
    this.setValueTotalTemp();
    this.onPageIndexChange.emit(value);
  }

  setValueTotalTemp(){
    this.startItem = (this.currentPage * this.pageSize) - this.pageSize + 1;
    this.endItem = this.currentPage * this.pageSize > this.totalItem ? this.totalItem : this.currentPage * this.pageSize;
  }

  clickExcel() {
    this.onClickBtnExcel.emit()
  }
}
